module.exports = __webpack_public_path__ + "static/media/teammember.2327c3e6.png";